import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  tap,
} from 'rxjs/operators';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-feeds-company-details-page',
  templateUrl: './feeds-company-details-page.component.html',
  styleUrls: ['./feeds-company-details-page.component.scss'],
})
export class FeedsCompanyDetailsPageComponent implements OnInit {
  searchQuery = '';
  companyData: any;
  companyList: any = [];
  selectedCompany :any
  ayList = [];
  selectedYear;
  selectedProductArray = [];
  productList = [];
  totalPrice = 0;
  loginEmail: any;
  isFree = false;
  plan:any;

  @ViewChild('searchOption') searchOption: ElementRef;
  isAdvance: boolean;
  isPremium: boolean;
  freeUser: boolean;
  deviceType;

  constructor(
    private router: Router,
    private companyService: CompanyService,
    private commonService: CommonService,
    private toastService: ToastService,
    private tansactionService: TansactionService,
    private loginSignupService: LoginSignupService,
    private localStorageService:LocalStorageService
  ) {
    this.deviceType = localStorageService.getItem('deviceType')
  }

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.plan = this.localStorageService.getItem('plan');
    if(this.plan == 'plan_advance'){
      this.isAdvance = true
    }else if(this.plan == 'plan_premium'){
      this.isPremium = true;
    }else {
      this.freeUser = true
    }
    this.isFree = false;
    if(this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null){
      this.isFree = false;
    }else{
        if (this.plan == 'free' || this.plan == 'plan_advance') {
          this.isFree = false;
        } else {
          this.isFree = true;
        }
    }
  }

  search(event) {
  if (this.searchOption.nativeElement.value.length > 0) {
      fromEvent(this.searchOption.nativeElement, 'keyup')
        .pipe(
          filter(Boolean),
          debounceTime(150),
          distinctUntilChanged(),
          tap((event: KeyboardEvent) => {
            if (this.searchOption.nativeElement.value != this.searchQuery) {
              this.searchQuery = this.searchOption.nativeElement.value;
              let requestData = {
                textSearch: this.searchOption.nativeElement.value,
              };
              this.commonService
                .searchOptionList(requestData)
                .then((data: any) => {
                  if (data.data.length > 0) {
                    this.companyList = data.data;
                  } else {
                    this.companyList = undefined;
                    if(this.isAdvance || this.isPremium){
                      this.router.navigate(['/company/search'], {
                        queryParams: { s: this.searchOption.nativeElement.value  },
                      });
                    }else{
                      this.router.navigate(['/financial/report']);
                      this.localStorageService.setItem('companyName-DNF',  this.searchOption.nativeElement.value);
                    }
                  }
                })
                .catch((err: any) => {
                  console.log(err)
                  this.companyList = undefined;
                });
            }
          })
        )
        .subscribe();
    } else {
      this.companyList = undefined;
    }
  }

  searchDataValue(companyInfo: any) {
    this.ayList = [];
    this.companyList = [];
    this.selectedCompany = companyInfo;
    this.searchOption.nativeElement.value = companyInfo.name;
    this.selectedYear = undefined;
    if(this.freeUser && (this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null)){
      this.router.navigate(['/financial/report']);
      this.localStorageService.setItem('companyName-DNF', companyInfo.name);
    }
    this.getHistoricalData(companyInfo.cin);
  }

  getHistoricalData(cin) {
    let request = { cin };
    this.companyService
      .getCompanyHistoricalDetails(request)
      .then((data: any) => {
        if (data.message) {
          this.toastService.addSingle('error', 'Error', data.message);
          this.router.navigate(['/company']);
        } else {
          this.companyData = data;
          let initialValue = {};

          this.companyData['roc_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'ROC'
            );
          this.companyData['pls_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'PLS'
            );
          this.companyData['bss_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'BSS'
            );
          this.companyData.product_list =
            this.companyData.product_list_arr.filter(
              (item) =>
                item.type !== 'BSS' &&
                item.type !== 'ROC' &&
                item.type !== 'PLS'
            );

          this.companyData.product_list = this.companyData.product_list.reduce(
            (obj, item) => {
              return {
                ...obj,
                [item['type']]: item,
              };
            },
            initialValue
          );
          this.generateUnique(this.companyData.pls_product_list);
          this.generateUnique(this.companyData.bss_product_list);
          this.ayList.sort(function (a, b) {
            return a.substring(0, 4) - b.substring(0, 4);
          });
          this.onOptionsSelected(this.ayList[this.ayList.length - 1]);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  generateUnique(list) {
    list.forEach((product) => {
      if (product.enable && !this.ayList.includes(product.ay)) {
        this.ayList.push(product.ay);
      }
    });
  }

  onOptionsSelected(year) {
    this.selectedYear = year;
    this.updateProductList();
  }

  updateProductSelection(product) {
    const index = this.selectedProductArray.indexOf(product);

    if (index > -1) {
      this.selectedProductArray.splice(index, 1);
    } else {
      this.selectedProductArray.push(product);
    }
    this.updateProductList();
  }

  updateProductList() {
    this.productList = [];
    this.totalPrice = 0;
    if (this.selectedProductArray.includes('pls')) {
      this.productList.push(
        ...this.companyData.pls_product_list.filter((product) => {
          return product.ay === this.selectedYear;
        })
      );
    }
    if (this.selectedProductArray.includes('bss')) {
      this.productList.push(
        ...this.companyData.bss_product_list.filter((product) => {
          return product.ay === this.selectedYear;
        })
      );
    }
    this.productList.forEach((product) => {
      this.totalPrice += product.price;
    });
  }

  addToCart() {
    this.productList.forEach(async (product) => {
      if (
        this.loginEmail == undefined ||
        this.loginEmail == '' ||
        this.loginEmail == null
      ) {
        this.localStorageService.setItem("redirect_url",this.router.url);
        this.router.navigate(['/user/login']);
      } else {
        let currentOption;
        currentOption = {
          sku: product.sku,
        };
        try {
          const data: any = await this.tansactionService.addProductToCart(currentOption);
          if (this.isFree) {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
        } catch (err) {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      }
    });
  }

  navigateToIndustryReport(){
    this.router.navigate([`/company/${this.selectedCompany.name}/roc`]);
  }
}
